

    import Vue from 'vue';

    import {mdbFooter, mdbContainer, mdbRow, mdbCol} from 'mdbvue';

    export default Vue.extend({
        components: {
            mdbFooter, 
            mdbContainer, 
            mdbRow, 
            mdbCol
        }
    });

